// 全局注册底部导航组件
import customFooter from "@/components/customFooter/customFooter";
// // 全局注册头部导航组件
import customHeader from "@/components/customHeader/customHeader";
// 全局注册时间picker
import datepicker from "@/components/datepicker/datepicker";
// 全局注册侧滑选择设备
import deviceList from "@/components/deviceList/deviceList";
// 全局注册图片封装器
import ImageProxy from "@/components/Image";
// 全局注册通用轻提示组件
import pageToast from "@/components/pageToast/pageToast";
//引入md5
import md5 from "js-md5";
import Vue from "vue";
// 引入微信jsdk
import wx from "weixin-js-sdk";
import App from "./App.vue";
// 引入接口调用文件
import api from "./axios/api";
import router from "./router";
import store from "./store";
// 引入rem配置文件
import "./utils/rem";
// 引入console
// import VConsole from 'vconsole'
// if (process.env.NODE_ENV === 'production') {
//   new VConsole()
// }
// 引入工具包JS文件
import "./utils/utils";
// 引入vantUI
import "./utils/vant";
// 引入语言包
import VueI18n from "./utils/vue-i18n";

Vue.prototype.$md5 = md5;

//import messages from './utils/lang.js'
Vue.use(VueI18n);

const messages = {
  zh: require("./utils/lan/zh.json"),
  en: require("./utils/lan/en.json"),
  ja: require("./utils/lan/ja.json"),
  es: require("./utils/lan/es.json"),
  ru: require("./utils/lan/ru.json"),
  ko: require("./utils/lan/ko.json")
};

// 引入多语言组件
const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "zh", // 默认选择的语言
  messages,
  silentTranslationWarn: true
});

// api挂载至Vue原型
Vue.prototype.$api = api;

window.wx = wx;
Vue.prototype.$wx = wx;

// 全局配置信息
Vue.config.productionTip = false;
const base = "https://api.ascod.cn";
// const base = "https://test.ascod.cn";

//const base = 'http://192.168.0.118'
Vue.prototype.$base = base;

Vue.component("ImageProxy", ImageProxy);
Vue.component("customHeader", customHeader);

Vue.component("customFooter", customFooter);

Vue.component("datepicker", datepicker);

Vue.component("deviceList", deviceList);

Vue.component("pageToast", pageToast);

// // 全局注册通用轻提示组件[解决一个作用域只能调用一次组件的问题]
// import pageToast2 from '@/components/pageToast/pageToast'
// Vue.component('pageToast2', pageToast2)

// // 全局注册通用轻提示组件[解决一个作用域只能调用一次组件的问题]
// import pageToast3 from '@/components/pageToast/pageToast'
// Vue.component('pageToast3', pageToast3)

// // 全局注册通用知情同意书组件
// import docAgree from '@/components/agreement/docAgree'
// Vue.component('docAgree', docAgree)

// // 全局注册通用所有的券组件
// import couponList from '@/components/coupon/couponList'
// Vue.component('couponList', couponList)

// // 全局注册通用所有的分类券组件
// import couponUseList from '@/components/coupon/couponUseList'
// Vue.component('couponUseList', couponUseList)

// // 全局注册通用微信支付码弹出组件
// import wxscanpayPop from '@/components/pay/wxscanpayPop'
// Vue.component('wxscanpayPop', wxscanpayPop)

// // 全局注册通用回到顶部组件
// import toTop from '@/components/toTop/toTop'
// Vue.component('toTop', toTop)

// // 全局注册通用微信关注组件
// import wxfollow from '@/components/wechatutils/wxfollow'
// Vue.component('wxfollow', wxfollow)

// // 全局注册通用时间进度组件
// import timeAxis from '@/components/timeAxis/timeAxis'
// Vue.component('timeAxis', timeAxis)

// // 全局注册通用计步器组件
// import stepper from '@/components/stepper/stepper'
// Vue.component('stepper', stepper)

// // 全局注册通用mv组件
// import mv from '@/components/mv/mv'
// Vue.component('mv', mv)

// // 全局注册通用建卡卡输入组件
// import writecard from '@/components/writecard/writecard'
// Vue.component('writecard', writecard)

// // 全局注册通用组件个人中心和安全退出
// import enter from '@/components/tool/enter'
// Vue.component('enter', enter)

// // 全局注册通用下单时填写用户信息
// import writeuserintro from '@/components/userintro/writeuserintro'
// Vue.component('writeuserintro', writeuserintro)

// // 全局注册通用AI加载组件
// import aiLoading from '@/components/aiLoading/aiLoading'
// Vue.component('aiLoading', aiLoading)
console.log("vue config :", Vue.config);

function formatConponentName(vm) {
  if (vm.$root === vm) {
    return "root instance";
  }
  let name = vm._isVue
    ? vm.$options.name || vm.$options._componentTag
    : vm.name;

  return (
    (name ? `conponent <${name}>` : "anonymous component") +
    (vm._isVue && vm.$options.__file ? ` at ${vm.$options.__file}` : "")
  );
}

// const _oldError = Vue.config.errorHandler;
// Vue.config.errorHandler = function(error, vm, info) {
//   const metaData = {};
//   if (Object.prototype.toString.call(vm) === "[object Object]") {
//     metaData.conponentName = formatConponentName(vm);
//     metaData.propsData = vm.$options.propsData;
//   }

//   if (typeof info !== "undefined") {
//     metaData.lifecycleHook = info;
//   }
// };
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
